var AnalyticsVersions;
(function (AnalyticsVersions) {
    AnalyticsVersions["Gtag"] = "gtag";
    AnalyticsVersions["GoogleTagManager"] = "gtm";
    AnalyticsVersions["Universal"] = "universal";
    AnalyticsVersions["Classic"] = "classic";
    AnalyticsVersions["GtagUniversal"] = "gtag-universal";
})(AnalyticsVersions || (AnalyticsVersions = {}));
export default AnalyticsVersions;
//# sourceMappingURL=AnalyticsVersions.js.map